import { tv } from 'tailwind-variants';

export const defaultVariants = tv({
  slots: {
    base: [],
    wrapper: [
      'w-full p-7.5',
      'flex flex-col items-center gap-5',
      'md:flex-row md:items-center md:gap-7.5',
      'bg-linear-to-t from-primary to-secondary',
    ],
    iconCol: ['flex justify-center shrink-0', 'ms-3.75'],
    iconWrapper: ['w-25 h-25', 'md:w-27.5 md:h-27.5'],
    contentCtaCol: [
      'flex flex-col justify-center items-start gap-3.5 ml:flex-row ml:items-center ml:flex-1 ml:gap-7.5 min-w-0',
    ],
    contentCol: ['flex flex-col gap-2.5 text-center min-w-0 md:text-left ml:flex-1', 'ctabar'],
    tipTitle: ['text-base font-semibold uppercase tracking-wide text-white'],
    heading: ['heading-3', 'text-white!'],
    ctaCol: ['flex justify-center md:justify-start shrink-0 ml:justify-end w-full ml:w-auto'],
  },
  variants: {
    override: {
      true: {
        tipTitle: 'text-current',
        heading: 'text-current!',
      },
    },
  },
});
